// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"a80739d7","990":"8aae3ed8"}[chunkId] + ".chunk.css";
};